import React from 'react';
import { useDispatch } from 'react-redux';
import {
  forgetPassword,
  LocalizePropType,
  withTextLocalizer,
} from 'getaway-data-layer';
import { useHistory } from 'react-router-dom';
import { useFormik } from 'formik';
import ForgotPasswordView from './ForgotPasswordView';
import { ForgotPasswordModal, ForgotPasswordSchema } from '../../../validation';
import { navigateTo } from '../../../utils';

interface Values {
  email: string;
}

type Props = {
  localize: LocalizePropType;
};

const ForgotPasswordContainer = ({ localize }: Props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const onSubmit = ({ email }: Values) => {
    dispatch(forgetPassword(email, null, null, localize, onPressBack));
  };

  const forgotPasswordFormik = useFormik({
    initialValues: ForgotPasswordModal,
    validationSchema: ForgotPasswordSchema(localize),
    onSubmit,
  });

  const onPressBack = () => {
    navigateTo(history, '/login');
  };

  return (
    <ForgotPasswordView
      localize={localize}
      formik={forgotPasswordFormik}
      onPressBack={onPressBack}
    />
  );
};

export default withTextLocalizer(ForgotPasswordContainer);
